import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    button: {
        height: 40
    },
    pages:{
        //height: '100vh'
    }
});
export default useStyles